import React from 'react';
import { Image, Upload } from 'lucide-react';

const Gallery = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Galería de Imágenes</h1>
        <p className="text-gray-600">Gestiona las imágenes del sitio web</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
        <Image className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <h3 className="text-xl font-bold text-gray-800 mb-2">Galería en Desarrollo</h3>
        <p className="text-gray-600 mb-6">La funcionalidad de galería estará disponible próximamente</p>
        <button
          className="inline-flex items-center gap-2 px-6 py-3 text-white rounded-lg font-semibold transition-all shadow-lg"
          style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}
          disabled
        >
          <Upload className="h-5 w-5" />
          Subir Imágenes
        </button>
      </div>
    </div>
  );
};

export default Gallery;